import React from 'react';
import './Footer.css'; // 스타일링을 위한 CSS 파일을 임포트합니다.

const Footer = () => {
  return (
    <footer>
    </footer>
  );
};

export default Footer;

